// extracted by mini-css-extract-plugin
module.exports = {"link":"ArrowLink-module--link--3Blhe","linkText":"ArrowLink-module--linkText--1-lMf"};